<script lang="ts">
	import type { Component } from "svelte"
	import { MaskSidebarController } from "./MaskEditorSidebarController"
	import SidebarCreate from "./Sidebar_Create.svelte"
	import SidebarEdit from "./Sidebar_Edit.svelte"
	import SidebarEmpty from "./Sidebar_Empty.svelte"
	import SidebarList from "./Sidebar_List.svelte"
	import SidebarImport from "./Sidebar_Import.svelte"
	import { Responsive } from "responsive"

	interface Props {
		showCanvas: boolean
	}

	let { showCanvas }: Props = $props()
	let isMobile = $derived(Responsive.isMobile)
	let doExpand = $derived(isMobile && !showCanvas)

	let activeMenu: MaskSidebarController.MenuOption = $state("new")
	MaskSidebarController.subscribe((ctx) => {
		activeMenu = ctx.menu
	})

	const MENU_OPTIONS: { [key in MaskSidebarController.MenuOption]: Component } = {
		empty: SidebarEmpty,
		edit: SidebarEdit,
		list: SidebarList,
		new: SidebarCreate,
		import: SidebarImport,
	}

	const SvelteComponent = $derived(MENU_OPTIONS[activeMenu])
</script>

<div id="sidebar" class:doExpand>
	<SvelteComponent />
</div>

<style>
	#sidebar {
		height: 100%;
		overflow: hidden;
		padding: 1rem 0.5rem 1rem 1rem;
		width: var(--sidebar-width);
		background-color: var(--color-bg-darker);
		display: flex;
		flex-direction: column;
	}

	#sidebar :global(.cancel-button) {
		padding-left: 0;
	}

	#sidebar :global(.cancel-button):hover,
	#sidebar :global(.cancel-button):focus-visible {
		transform: unset;
	}

	#sidebar :global(h2) {
		font-size: var(--h0);
		margin: 0;
	}

	#sidebar :global(.info) {
		color: var(--color-text);
		margin-bottom: 0;
	}

	#sidebar :global(hr) {
		margin: 0.5rem 0;
	}

	#sidebar :global(.create-buttons) {
		margin-bottom: 0;
		align-items: center;
	}

	#sidebar :global(.create-buttons:not(:has(.cancel-button)) .create-button) {
		width: 100%;
	}

	:global(.isMobile) #sidebar {
		padding: 0.5rem;
		height: fit-content;
		overflow: unset;
	}

	:global(.isMobile) #sidebar :global(.input-container input) {
		width: 100%;
	}

	:global(.isMobile) #sidebar :global(h3) {
		font-size: var(--h1);
	}

	:global(.isMobile) #sidebar :global(.info) {
		margin: 0;
		font-size: var(--h3);
	}

	:global(.isMobile) #sidebar :global(.link-button) {
		padding: 0;
	}

	:global(.isMobile) #sidebar :global(.button-container) {
		padding: 0;
	}

	:global(.isMobile) #sidebar :global(.button-container button) {
		font-size: var(--h2);
		margin: 0;
	}

	#sidebar.doExpand {
		max-height: unset;
		flex-grow: 1;
	}
</style>
